import { Icon } from "@mui/material";
import { UserPermissions } from "generated/graphql";
import AuthWall from "modules/AuthWall/AuthWall";
import AuthWallSubscriber from "modules/AuthWallSubscriber/AuthWallSubscriber";

import CompaniesPage from "pages/companies";
import CreateCompanyPage from "pages/companies/create";
import CompanyJobsCreatePage from "pages/companies/jobs/create";
import CompanyProposalsCreatePage from "pages/companies/proposals/create";
import UpdateCompanyPage from "pages/companies/update";
import ViewCompanyPage from "pages/companies/view";

const companyRoutes = [
  {
    type: "internal",
    name: "Contacts",
    key: "companies.list",
    route: "/companies",
    permission: UserPermissions.VIEW_COMPANIES,
    icon: <Icon fontSize="medium">business</Icon>,
    component: (
      <AuthWall permission={UserPermissions.VIEW_COMPANIES}>
        <AuthWallSubscriber>
          <CompaniesPage />
        </AuthWallSubscriber>
      </AuthWall>
    ),
  },
  {
    name: "Create Contact",
    key: "companies.create",
    permission: UserPermissions.MANAGE_COMPANIES,
    route: "/companies/create",
    component: (
      <AuthWall permission={UserPermissions.MANAGE_COMPANIES}>
        <AuthWallSubscriber>
          <CreateCompanyPage />
        </AuthWallSubscriber>
      </AuthWall>
    ),
  },
  {
    type: "internal",
    name: "Create Proposal",
    key: "companies.proposals.create",
    route: "/companies/:companyId/proposals/create",
    component: (
      <AuthWall>
        <AuthWallSubscriber>
          <CompanyProposalsCreatePage />
        </AuthWallSubscriber>
      </AuthWall>
    ),
  },
  {
    type: "internal",
    name: "Create Job",
    key: "companies.jobs.create",
    route: "/companies/:companyId/jobs/create",
    component: (
      <AuthWall>
        <AuthWallSubscriber>
          <CompanyJobsCreatePage />
        </AuthWallSubscriber>
      </AuthWall>
    ),
  },
  {
    type: "internal",
    name: "View",
    key: "companies.view",
    permission: UserPermissions.VIEW_COMPANIES,
    route: "/companies/:companyId",
    component: (
      <AuthWall permission={UserPermissions.VIEW_COMPANIES}>
        <AuthWallSubscriber>
          <ViewCompanyPage />
        </AuthWallSubscriber>
      </AuthWall>
    ),
  },
  {
    type: "internal",
    name: "Update",
    key: "companies.update",
    route: "/companies/:companyId/update",
    permission: UserPermissions.MANAGE_COMPANIES,
    component: (
      <AuthWall permission={UserPermissions.MANAGE_COMPANIES}>
        <AuthWallSubscriber>
          <UpdateCompanyPage />
        </AuthWallSubscriber>
      </AuthWall>
    ),
  },
] as const;

export default companyRoutes;
